<template>
    <div class="security-box">
        <dialog-video :show="showTipView" :x="positionX" :y="positionY" :itemData="cameraIndexCode" @showChange="showTipView = false">
        </dialog-video>
    </div>
</template>

<script>

import { cameraList } from '@/api/security'
import coordtransform from 'coordtransform'
import DialogVideo from '@/components/yt-component/DialogVideo'

import PubSub from 'pubsub-js'
import { Message } from 'element-ui'

export default {
  components: {
    DialogVideo
  },
  data () {
    return {
      canLeave: false,
      // 地图点击事件
      positionX: 0,
      positionY: 0,
      showTipView: false,
      cameraList: [],
      cameraIndexCode: null
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.canLeave) {
      next()
    } else {
      Message('地图正在渲染请稍后再切换页面')
    }
  },
  created () {
    setTimeout(() => {
      this.cameraPosition(-99087.75, -1921.799072265625, 47684.9921875, 34.98421096801758, -86.65238189697266, -124.96226501464844)
    }, 0)
  },
  mounted () {

  },
  beforeDestroy () {
    const inspur = this.$store.state.inspurMap
    const markerInstance = new inspur.Marker()
    markerInstance.clear()
  },
  methods: {
    // 获取摄像头
    getCameraList () {
      const time1 = (new Date()).valueOf()
      cameraList().then((res) => {
        const time2 = (new Date()).valueOf()
        const time3 = time2 - time1
        console.log('获取摄像头数据用时：' + time3)
        if (res.code === 200) {
          const data = res.data
          this.cameraList = data
          this.findVideoUrl()
          const cameraArr = data.map((item) => {
            const coord = coordtransform.gcj02towgs84(
              item.longitude,
              item.latitude
            )
            return {
              scale: 0.4,
              id: item.id,
              // name: item.name,
              isGraphic: true,
              visible: true,
              type: 'camera',
              cameraIndexCode: item.cameraIndexCode,
              position: {
                x: coord[0],
                y: coord[1],
                z: 20
              }
            }
          })
          const inspur = this.$store.state.inspurMap
          const markerInstance = new inspur.Marker()
          this.addMarker(markerInstance, cameraArr)
        } else {
          this.canLeave = true
        }
      })
    },
    findVideoUrl () {
      PubSub.subscribe('addTipView', (msg, obj) => {
        console.log('接受到了订阅')
        console.log(msg)
        console.log(obj)
        console.log(this.cameraList)
        this.cameraList.forEach((item) => {
          if (parseInt(obj.id) === item.id) {
            console.log(item)
            this.cameraIndexCode = item
          }
        })
        this.positionX = obj.x + 'px'
        this.positionY = obj.y + 'px'
        this.showTipView = true
      })
    },
    // 设置标注点
    addMarker (markerInstance, points) {
      for (const pointInfo of points) {
        markerInstance.add(pointInfo)
      }
      this.canLeave = true
    },
    // 调整相机角度
    async cameraPosition (x, y, z, roll, pitch, yaw) {
      const time1 = (new Date()).valueOf()
      const inspur = this.$store.state.inspurMap
      const position = {
        x,
        y,
        z,
        rotation: {
          roll,
          pitch,
          yaw
        }
      }
      const camera = new inspur.Camera()
      await camera.flyTo(position)
      const time2 = (new Date()).valueOf()
      const time3 = time2 - time1
      console.log('地图视角调整完成用时：' + time3)
      this.getCameraList()
    }
  }
}
</script>

<style lang="scss" scoped>
.security-box {
    width: 100%;
    height: 100%;
    position: relative;
    .home-center-panel {
        pointer-events: auto;
        position: absolute;
        top: 100px;
        left: 28%;
        width: 40%;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
    }
    .home-left-panel {
        pointer-events: auto;
        position: absolute;
        top: 0;
        left: 30px;
        bottom: 54px;
        width: 25%;
        background: url('../assets/left-panel.png') no-repeat;
        background-size: 100% 100%;
        padding: 80px 80px 40px 80px;
        .panel-two {
            padding: 10px 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .left-panel-btn {
            padding: 4px 10px;
            margin-left: 16px;
            cursor: pointer;
            color: #fff;
            border: 2px solid #fff;
            border-radius: 6px;
        }
        .panel-btn-active {
            color: #00fff6;
            border: 2px solid #00fff6;
        }
        .video-box {
            width: 100%;
            height: 420px;
        }
        .video-wrap {
          width: 100%;
          height: 640px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
        }
        .radar-box {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .text-box {
                width: 50%;
            }
        }
    }
    .home-right-top {
        pointer-events: auto;
        position: absolute;
        top: 0;
        right: 30px;
        width: 25%;
        height: 460px;
        box-sizing: border-box;
        background: url('../assets/security-right.png') no-repeat;
        background-size: 100% 100%;
        padding: 20px;
        .radar-box {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-top: 20px;
            .text-box {
                width: 50%;
                height: 100%;
                display: flex;
                flex-wrap: wrap;
                .text-item {
                  width: 100%;
                  display: flex;
                  padding: 10px 0;
                  .text-title {
                    color: #00fff6;
                    padding-left: 30px;
                    width: 60%;
                  }

                }
            }
        }
    }
}
.alarm-wrapper {
    width: 100%;
    height: 100%;
    .title-list {
        width: 100%;
        line-height: 100px;
        display: flex;
        justify-content: space-between;
        padding: 0 60px;
        .title-item {
            display: flex;
            justify-content: center;
            font-size: 22px;
            font-weight: 600;
            color: #02f6ff;
        }
    }
    .data-wrapper {
        width: 100%;
        height: calc(100% - 110px);
        overflow: hidden;
        overflow-y: auto;
        .data-list {
            width: 100%;
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #9e9e9e;
            padding: 20px;
            .data-item {
                width: 200px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
     .pagination-box {
      width: 100%;
      height: 60px;
      padding: 0 60px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    .alarmImg {
        width: 200px;
        height: 100px;
    }
}
.tip-view {
    color: #fff;
    background-color: rgba(82, 89, 103, 0.6);
    padding: 16px;
    border-radius: 4px;
}
.video-box {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow-y: auto;
  white-space: nowrap;
  &::-webkit-scrollbar {
      display: none;
  }
}
</style>
